module.exports = __webpack_public_path__ + "img/pexel2.635df844.jpg";